import { BRAND_COLORS, ERROR_COLORS, FONT_WEIGHTS, GRAY_COLORS, SHADOWS } from '../globalTheme';

export const theme = {
	textArea: {
		size: {
			auto: { width: 'auto', padding: '10px 14px', fontSize: '16px' }
		},
		textAreaBorder: {
			border: `1px solid ${GRAY_COLORS.gray300}`,
			borderRadius: '8px'
		},
		backgroundColor: 'white',
		textAreaShadow: SHADOWS.xs,
		focused: {
			border: `1px solid ${BRAND_COLORS.brand300}`,
			boxShadow: `0px 0px 0px 4px ${BRAND_COLORS.brand100}`
		},
		disabled: {
			background: GRAY_COLORS.gray100,
			color: GRAY_COLORS.gray400
		},
		error: {
			border: `1px solid ${ERROR_COLORS.error300}`
		},
		errorFocused: {
			boxShadow: `0px 0px 0px 4px ${ERROR_COLORS.error100}`
		}
	},
	placeholder: {
		weight: FONT_WEIGHTS.regular
	}
};
export type Theme = typeof theme;
